import { render } from "./OverviewComponent.vue?vue&type=template&id=05bc81dc&scoped=true"
import script from "./OverviewComponent.vue?vue&type=script&lang=js"
export * from "./OverviewComponent.vue?vue&type=script&lang=js"

import "./OverviewComponent.vue?vue&type=style&index=0&id=05bc81dc&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05bc81dc"],['__file',"resources/js/components/frontend/account/overview/OverviewComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05bc81dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05bc81dc', __exports__)) {
    api.reload('05bc81dc', __exports__)
  }
  
  module.hot.accept("./OverviewComponent.vue?vue&type=template&id=05bc81dc&scoped=true", () => {
    api.rerender('05bc81dc', render)
  })

}


export default __exports__